<span [ngClass]="{ 'text-small': textSmall }">{{ amount }}</span>
